import { uploadAliOSS, GOODS_IMAGE_SEARCH } from '@/util/useUpload'
import vueRouter from '@/router'
import store, { useRtfix } from '@/store'
// import { useStore } from 'vuex'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { searchUpload } from '@/apis/search'
import axios from 'axios'
const route = vueRouter.currentRoute.value
const router = vueRouter
export const searchByImage = (file: any) => {
  return new Promise((resolve, reject) => {
    confirmLoginWithNoCurShop(async () => {
      store.commit('status/loading', true)
      const searchRes:any = await searchByBase64(file)
      let res1:any = null
      const urlData:any = await upFileToAliOss(file)
      if (searchRes.status) {
        res1 = await searchUpload({ imageBase64: searchRes.data.split(',')[1] })
      }
      if ((!searchRes.status) || (!(res1.success && res1.data !== '0'))) {
        res1 = await searchUpload({ imageUrl: urlData?.url })
      }
      store.commit('status/loading', false)
      if (res1.success) {
        navigateToImageSearch(urlData?.url, res1.data)
      }
      resolve(urlData)
    }, () => {
      reject(Error())
    })
  })
}

const upFileToAliOss = async (file:any) => {
  const res = await uploadAliOSS({
    file: file,
    path: GOODS_IMAGE_SEARCH,
    bizType: 'searchPic',
    readAuto: true
  })
  return res
}

/**
 * 导航去search数据
 * @param url 请求数据
 * @param imageId 为0时再次将URL处理一下
 * @returns
 */
export const navigateToImageSearch = async (url: string, imageId: string | undefined = undefined) => {
  const query: any = {}
  if (!imageId || imageId === '0') {
    store.commit('status/loading', true)
    const params:any = { imageUrl: url, imageBase64: '' }
    try {
      if (imageId === '0') {
        const res = await urlToBase64(url)
        res && (params.imageBase64 = res.split(',')[1])
      }
    } catch (error) {

    } finally {
      const res1 = await searchUpload(params)
      store.commit('status/loading', true)
      if (res1.success) {
        query.imageId = res1.data
      }
    }
  } else {
    query.imageId = imageId
  }

  query.imageUrl = url
  router[route.name?.toString().includes('list') ? 'replace' : 'push'](
    useRtfix('list', { query })
  )
}

/**
 * file转化base64
 * @param file
 * @returns
 */
export const searchByBase64 = (file: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let canvas
    const URL = window.URL || window.webkitURL
    const blob = URL.createObjectURL(file)
    const img = new Image()
    img.src = blob
    img.onload = function () {
      const that = this as any
      const rate = file.size > 200 * 1024 ? 0.7 : 1

      const w = that.width * rate
      const h = that.height * rate
      // 生成canvas
      canvas = document.createElement('canvas')
      canvas.width = w
      canvas.height = h
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
      // document.append(canvas)
      ctx.drawImage(that, 0, 0, w, h)
      const base64 = canvas.toDataURL('image/jpeg', rate)
      // if (process.env.NODE_ENV === 'development') {
      //   const el = document.createElement('a')
      //   el.href = base64
      //   el.download = '文件名称'
      //   const event = new MouseEvent('click')
      //   el.dispatchEvent(event)
      // }
      resolve({ status: true, data: base64 })
    }
    img.onerror = () => {
      resolve({ status: false })
    }
  })
}

const getBase64ImageSize = (base64: any): number => {
  if (base64) {
    base64 = base64.split(',')[1].split('=')[0]
    const strLength = base64.length
    const fileLength = strLength - (strLength / 8) * 2
    return Math.floor(fileLength)
  } else {
    return 0
  }
}

export const urlToBase64 = (imageUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    try {
      axios.get(imageUrl, {
        responseType: 'blob'
      }).then((res) => {
        // 至关重要
        const oFileReader = new FileReader()
        // 下面代码为blob转base64
        oFileReader.readAsDataURL(res.data)
        oFileReader.onloadend = function (e: any) {
          const baseBuff = e.target.result
          resolve(baseBuff)
        }
      }).catch(() => {
        reject(new Error('图片转base64失败'))
      })
    } catch (error) {
      resolve('')
    }
  })
}
